<template>
    <div class="container">
        <menus></menus>
        <div class="main">
            <!-- 内容 -->
            <div class="user">
                <span>{{ $t('welcome.welcome') }}</span><span>{{ phone }}</span><span @click="signOut" style="color:#fff">{{
                    $t('welcome.signOut')
                }}</span>
            </div>
            <div>
                <div class="mainTitle" :style="{ 'font-size': $i18n.locale == 'jp' ? '.35rem' : '' }">
                    {{ $t('guest.timetable.title') }}</div>
                <div class="mainBody">
                    <p style="line-height:0.45rem;"><span class="red">{{
                        $t('guest.timetable.title1')
                    }}:</span><br>{{ $t('guest.timetable.tips.six') }}
                        <br>{{ $t('guest.timetable.tips.seven') }}
                        <br>{{ $t('guest.timetable.tips.seven1') }}
                        <br>{{ $t('guest.timetable.tips.seven2') }}
                        <br>3、{{ $t('guest.timetable.tips.eight1').split('：')[0]}}：<br>
                        <i style="opacity:0">3、</i>周<i style="opacity:0">裕</i>裕 <a href="tel:18124610303" style="color:#fff">181 2461 0303</a>
                        <br><i style="opacity:0">3、</i>{{ $t('guest.timetable.tips.eight2').split('：')[0]}}：<br>
                        <i style="opacity:0">3、</i>{{ $t('guest.timetable.tips.eight2').split('：')[1]
                        }} <a href="tel:13826138297" style="color:#fff">138 2613 8297</a>
                    </p>
                    <p style="line-height:0.45rem;">
                        <span class="red">{{ $t('guest.timetable.tips.three') }}</span>
                    </p>
                    <p style="line-height:0.45rem;">{{ $t('guest.timetable.tips.five') }}</p>
                    <img class='preview-img' width="100%" widths="1520" heights="1526"
                        links="https://oss.eventnet.cn/H5/Nissan_meeting/2024/map1111.jpg?v=0223"
                        src='https://oss.eventnet.cn/H5/Nissan_meeting/2024/map1111.jpg?v=0223' @click="bigImg">
                </div>
                <div class="mainTitle" :style="{ 'font-size': $i18n.locale == 'jp' ? '.29rem' : '' }"
                    style="margin-top: .3rem;">
                    {{ $t('guest.timetable.tips1_title') }}</div>
                <div class="mainBody">
                    <p style="line-height:0.45rem;"><span class="red">{{
                        $t('guest.timetable.place1.name')
                    }}</span><br>{{ $t('guest.timetable.place1.time1') }}
                        <br>{{ $t('guest.timetable.place1.time2') }}<br>
                    </p>
                    <p style="line-height:0.45rem;"><span class="red">{{
                        $t('guest.timetable.place2.name')
                    }}</span><br>{{ $t('guest.timetable.place2.time1') }}
                    <br>{{ $t('guest.timetable.place2.time2') }}<br>
                </p>
                    <p style="line-height:0.45rem;">
                        <span class="red">{{ $t('guest.signin.place11') }}</span><br>
                            {{ $t('guest.timetable.contact.name2') }}
                        <a href="tel:18124610303" style="color:#fff">181 2461 0303</a>
                    </p>
                    <p style="line-height:0.45rem;">
                        <span class="red">{{ $t('guest.timetable.place.title') }}:</span><br>{{
                            $t('guest.timetable.place.name')
                        }}
                    </p>
                    <p style="line-height:0.45rem;">
                        <span class="red">{{ $t('guest.timetable.tips.title') }}</span><br>
                        {{ $t('guest.timetable.tips.one') }}<br>{{ $t('guest.timetable.tips.two') }}<br>
                    </p>
                    <p style="line-height:0.45rem;">
                        <span class="red">{{ $t('guest.timetable.tips.three') }}</span><br>{{
                            $t('guest.timetable.tips.four')
                        }}
                    </p>
                </div>
            </div>
        </div>
        <div class="back" @click="path('menu')" :style="{ 'font-size': $i18n.locale == 'jp' ? '.2rem' : '.28rem' }">
            <img width="100%" src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/back.png" alt="">
        </div>
        <Photo class="img_big" :items="items" v-if="bigImg_show" @show="close" />
    </div>
</template>
<script>
import menus from "../../components/menu.vue"
import Photo from '../../components/PhotoSwipe';
export default {
    components: {
        menus,
        Photo
    },
    name: "menuView",
    data() {
        return {
            phone: localStorage.getItem("nissan2023_meeting_mobile"),
            items: [{
                src: '',
                w: 0,
                h: 0,
            },],
            bigImg_show: false,
        }
    },
    created() {
        //_hmt.push(['_trackPageview', '/guest/timetable']);
    },
    mounted() {
        // this.alerts3("<p style='text-align:left;'>" + this.$t('tips.tips3') + "</p>");
    },
    methods: {
        bigImg(el) {
            this.items[0].w = el.target.getAttribute('widths');
            this.items[0].h = el.target.getAttribute('heights');
            this.items[0].src = el.target.getAttribute('links');
            this.bigImg_show = true;
        },
        close(e) {
            this.bigImg_show = e;
        },
        alerts3(content) {
            layer.open({
                title: [
                    this.$t('tips.tips1'),
                    'background-color: #c61533; color:#fff;'
                ],
                content: content,
                btn: this.$t('tips.tips2'),
                yes: function (index) {
                    layer.closeAll();
                }
            });
        },
        signOut() {
            localStorage.removeItem("nissan2023_meeting_uuid")
            this.$router.replace('/login');
        },
        path(path) {
            this.$router.replace('/' + path)
        }
    }
}
</script>
<style scoped>
.container {
    padding-bottom: .5rem;
}
</style>


// WEBPACK FOOTER //
// src/views/guest/timetable.vue